/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WebauthnControllerAdminFindByUser200ResponseDataInner { 
    id?: string;
    name?: string;
    /**
     * singleDevice | multiDevice (sincronizable)
     */
    deviceType?: string;
    backedUp?: boolean;
    /**
     * Gestor donde vive la llave (iCloud Keychain, Google...), si se reconoce
     */
    provider?: string;
    transports?: Array<string>;
    rpId?: string;
    createdOn?: string;
    lastUsedAt?: string;
}

